import { FilterQueryParams } from '~/composables/useUiHelpers/types'

export const DEFAULT_QUERY_VALUES: FilterQueryParams = {
  page: '1',
  itemsPerPage: '32',
  sort: '',
  display: ''
}
